import axiosClient from "./axiosClient";

const userApi = {

    getProduct() {
        const url = `Product/GetAll`;
        return axiosClient.get(url);
    },

    getProductById(id) {
        const url = `ProductDetail/?url=${id}`;
        return axiosClient.get(url);
    },

    addToCart(data) {
        const url = `Payment/GetListPrice`;
        return axiosClient.post(url, data);
    },


}

export default userApi;